import {
  REGISTER,
  AUTH_ERROR,
  LOGIN,
  LOGOUT,
  SET_LOADING,
  RESET_LOADING,
  LOAD_USER_PROFILE,
} from "../types";
import { AuthActions } from "../types/auth";
import { authR } from "../types/reducers";
import { User } from "../../models/user";
// import uuid from "uuid/v1"

export const iusr: User = {
  username: "",
  accountType: "",
  bio: "",
  email: "",
  fans: [],
  firstName: "",
  id: "",
  lastName: "",
  location: {
    city: "",
    country: "",
  },
  pimage: "",
  website: "",
  img: "",
};

const initState: authR = {
  loading: false,
  user: iusr || null,
  isAuthenticated: false,
  otherUsr: iusr || null,
};

const authReducer = (state = initState, action: AuthActions): authR => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN:
    case REGISTER:
      return {
        ...state,
        user: payload,
        isAuthenticated: true,
        loading: false,
      };
    case LOGOUT:
    case AUTH_ERROR:
      return {
        ...state,
        loading: false,
        user: {
          username: "",
          accountType: "",
          bio: "",
          email: "",
          fans: [],
          firstName: "",
          id: "",
          lastName: "",
          location: {
            city: "",
            country: "",
          },
          pimage: "",
          website: "",
          img: "",
        },
        isAuthenticated: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESET_LOADING:
      return {
        ...state,
        loading: false,
      };

    case LOAD_USER_PROFILE:
      return {
        ...state,
        otherUsr: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default authReducer;
